import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"table-head-wrapper soil-table-head-wrapper\"><table id=\"tableHead\" class=\"table-head\"><tr><th class=\"row2\" rowspan=\"2\">観察地点</th><th class=\"row2\" rowspan=\"2\">該当エリア</th><th>10分雨量</th><th>1時間雨量</th><th>2時間雨量</th><th>3時間雨量</th><th>土壌雨量指数</th><th>水位</th></tr><tr><th>mm</th><th>mm</th><th>mm</th><th>mm</th><th>mm</th><th>m</th></tr></table></div>", 1)
const _hoisted_2 = { id: "soil-table" }

import { onMounted, onUnmounted, PropType, nextTick } from 'vue'
import $ from 'jquery'

type Row = {
  values: (string | undefined)[]
}

type Threshold = {
  color: string
  comparison: number
  type: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  rows: {
    type: Array as PropType<Row[]>,
    default: () => [],
  },
  thresholds: {
    type: Array as PropType<Threshold[]>,
    default: () => [],
  },
  style: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



onMounted(() => {
  nextTick(() => {
    width_resize()
    colorChange()
  })
})
onUnmounted(() => {
  window.removeEventListener('resize', width_resize)
  window.removeEventListener('change', colorChange)
})

function colorChange() {
  const rows = props.rows
  const thresholds = props.thresholds
  const tableTr = $('#soil-table tr')

  for (let i = 0; i < rows.length; i++) {
    if (
      Number(rows[i].values[2]) >= Number(thresholds[0].comparison) &&
      Number(rows[i].values[2]) < Number(thresholds[1].comparison)
    ) {
      tableTr.eq(i).children().eq(2).addClass('rain-caution')
    }
    if (Number(rows[i].values[2]) >= Number(thresholds[1].comparison)) {
      tableTr.eq(i).children().eq(2).addClass('rain-warning')
    }
    if (Number(rows[i].values[3]) >= Number(thresholds[2].comparison)) {
      tableTr.eq(i).children().eq(3).addClass('rain-warning')
    }
    if (Number(rows[i].values[4]) >= Number(thresholds[3].comparison)) {
      tableTr.eq(i).children().eq(4).addClass('rain-warning')
    }
    if (Number(rows[i].values[5]) >= Number(thresholds[4].comparison)) {
      tableTr.eq(i).children().eq(5).addClass('rain-warning')
    }
    if (
      Number(rows[i].values[6]) >= Number(thresholds[5].comparison) &&
      Number(rows[i].values[6]) < Number(thresholds[6].comparison)
    ) {
      tableTr.eq(i).children().eq(6).addClass('soil-caution')
    }
    if (
      Number(rows[i].values[6]) >= Number(thresholds[6].comparison) &&
      Number(rows[i].values[6]) < Number(thresholds[7].comparison)
    ) {
      tableTr.eq(i).children().eq(6).addClass('soil-warning')
    }
    if (Number(rows[i].values[6]) >= Number(thresholds[7].comparison)) {
      tableTr.eq(i).children().eq(6).addClass('soil-danger')
    }
  }
}

function width_resize() {
  if ($('.table-body-wrapper tr').eq(0)) {
    $('#soil-table tr').eq(0).children().eq(0).width(199)
    $('.table-head-wrapper').width($('.table-body-wrapper').width() as number)
    let width = $('.table-body-wrapper tr').eq(0).children().eq(0).width() as number
    $('.table-head-wrapper tr')
      .eq(0)
      .children()
      .eq(0)
      .width(width - 1)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "table-body-wrapper",
      style: _normalizeStyle(__props.style)
    }, [
      _createElementVNode("table", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (row, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values, (value, index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(value), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ], 4)
  ], 64))
}
}

})